import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCandidates } from '../api';
import '../styles/CandidatesSection.css';

const CandidatesSection = () => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCandidates()
      .then(data => {
        console.log('Кандидаты:', data); // для отладки
        setCandidates(Array.isArray(data) ? data.slice(0, 6) : []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Ошибка загрузки кандидатов:', err);
        setLoading(false);
      });
  }, []);

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `http://localhost:5000${path}`;
  };

  if (loading) return <div>Загрузка кандидатов...</div>;
  if (candidates.length === 0) return null;

  return (
    <section className="candidates-section">
      <div className="container">
        <div className="candidates-grid">
          {candidates.map(candidate => (
            <Link to={`/candidate/${candidate.id}`} key={candidate.id} className="candidate-card">
              <div className="candidate-photo">
                {candidate.photo ? (
                  <img src={getImageUrl(candidate.photo)} alt={candidate.name} />
                ) : (
                  <div className="no-photo">Нет фото</div>
                )}
              </div>
              <h3>{candidate.name}</h3>
              <p className="candidate-position">{candidate.position}</p>
              <p className="candidate-bio">{candidate.bio?.slice(0, 100)}...</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CandidatesSection;